export const variantOrDefaultVariant = (stencil) => {
  // if a variant is selected, return it
  if (stencil.variant) return stencil.variant;

  // search default variant
  return stencil.product.variants.find((v) => v.is_default);
}

export const extractStencils = (arg) => {
  const { stencils } = arg;
  if (!stencils || !stencils.length) return {};

  const quantity = stencils.length;
  let price = 0;
  stencils.forEach((stencil) => {
    const variant = variantOrDefaultVariant(stencil);
    if (!variant) return;

    price += parseFloat(variant.price);
  });
  const unitPrice = accounting.toFixed(price / quantity, 2);
  return {
    quantity,
    unitPrice,
    subTotal: price,
    selected: true,
  };
}